/* ============================================================
   ÉTAPE 1: INFORMATIONS DE BASE (Refactorisée)
   ============================================================ */

import { Lightbulb } from 'lucide-react';
import { useEffect, useState } from 'react';
import { generateSlug } from '../../../../utils/space.utils';
import { SaveButton } from '../SaveButton';
import { SpaceImageUpload } from '../SpaceImageUpload';
import { WorkflowSelector } from '../WorkflowSelector';

interface Step1BasicInfoProps {
  data: any;
  onChange: (updates: any) => void;
  onSave?: () => void;
  isSaving?: boolean;
}

export function Step1BasicInfo({ data, onChange, onSave, isSaving }: Step1BasicInfoProps) {
  const [name, setName] = useState(data.name || '');
  const [slug, setSlug] = useState(data.slug || '');
  const [shortDesc, setShortDesc] = useState(data.shortDesc || '');
  const [description, setDescription] = useState(data.description || '');
  const [workflow, setWorkflow] = useState(data.workflow || 'IMMEDIATE');
  const [imageUrl, setImageUrl] = useState(data.imageUrl || '');

  useEffect(() => {
    if (name) {
      const newSlug = generateSlug(name);
      setSlug(newSlug);
      onChange({ name, slug: newSlug, shortDesc, description, workflow, imageUrl });
    }
  }, [name]);

  useEffect(() => {
    onChange({ name, slug, shortDesc, description, workflow, imageUrl });
  }, [shortDesc, description, workflow, imageUrl]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>Nom de l'espace *</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex: Salle de Conférence" style={{ width: '100%', padding: '0.875rem 1rem', fontSize: '1rem', border: '2px solid #e5e7eb', borderRadius: '12px', outline: 'none' }} />
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>Slug (URL) *</label>
        <input type="text" value={slug} readOnly style={{ width: '100%', padding: '0.875rem 1rem', fontSize: '1rem', border: '2px solid #e5e7eb', borderRadius: '12px', fontFamily: 'monospace', background: '#f8fafb', color: '#666' }} />
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>Description courte *</label>
        <input type="text" value={shortDesc} onChange={(e) => setShortDesc(e.target.value.slice(0, 80))} placeholder="Max 80 caractères" maxLength={80} style={{ width: '100%', padding: '0.875rem 1rem', fontSize: '1rem', border: '2px solid #e5e7eb', borderRadius: '12px' }} />
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>Description complète *</label>
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Description détaillée..." rows={6} style={{ width: '100%', padding: '0.875rem 1rem', fontSize: '1rem', border: '2px solid #e5e7eb', borderRadius: '12px', resize: 'vertical' }} />
      </div>

      <SpaceImageUpload imageUrl={imageUrl} onImageChange={(url) => setImageUrl(url)} onRemove={() => setImageUrl('')} />

      <WorkflowSelector currentWorkflow={workflow} onSelect={setWorkflow} />

      <div style={{ padding: '1rem', background: '#f0f9ff', borderRadius: '12px', border: '1px solid #bae6fd' }}>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Lightbulb size={20} color="#00758d" />
          <p style={{ fontSize: '0.85rem', color: '#00303c', margin: 0 }}><strong>Prochaines étapes :</strong> Vous pourrez configurer les modules spécifiques après.</p>
        </div>
      </div>

      {onSave && <SaveButton onSave={onSave} isSaving={isSaving || false} disabled={!name || !slug || !description} />}
    </div>
  );
}
